import React from 'react';

const Footer = () => {
  return (
    <>
      <hr width="100%" />
      <footer className="row" style={{ width: '100%', textAlign: 'center', color: '#999999' }}>
        <p style={{ width: '100%', display: 'block', margin: '0 auto', textAlign: 'center', color: '#999999' }}>
          Funding and support provided by the <a href="https://neh.gov/">National Endowment for the Humanities</a>,
          the <a href="https://cah.ucf.edu">College of Arts and Humanities</a>, <br />
          and&nbsp;the <a href="https://chdr.cah.ucf.edu/">Center for Humanities and Digital Research</a> at
          the <a href="https://ucf.edu/">University of Central Florida</a>
        </p>

        <p style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', paddingTop: '10px' }}>
          <a href="https://neh.gov/" target="_blank" rel="noopener noreferrer">
            <img
              src={`${process.env.PUBLIC_URL}/images/footer/neh-logo.png`}
              alt="National Endowment for the Humanities logo"
              style={{ maxWidth: 'auto', height: 'auto' }}
            />
          </a>

          <a href="https://ucf.edu/" target="_blank" rel="noopener noreferrer">
            <img
              src={`${process.env.PUBLIC_URL}/images/footer/ucf-logo.png`}
              alt="University of Central Florida logo"
              style={{ maxWidth: 'auto', height: 'auto' }}
            />
          </a>
        </p>
      </footer>
    </>
  );
};

export default Footer;
